import { motion } from "framer-motion";
import { marqueeSkills } from "@/data/portfolio";

export default function Marquee() {
  const items = [...marqueeSkills, ...marqueeSkills];
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-white/5 bg-black py-8 md:py-10 overflow-hidden"
      aria-label="Technical skills marquee"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-black to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-black to-transparent z-10" />
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="flex"
      >
        <div className="marquee-track flex shrink-0 items-center gap-12 pr-12 whitespace-nowrap">
          {items.map((s, i) => (
            <span
              key={`${s}-${i}`}
              className="inline-flex items-center gap-12 font-heading text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-zinc-600 hover:text-white transition-colors"
            >
              {s}
              <span className="text-zinc-800 text-2xl">✱</span>
            </span>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
